import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';
// import { navigateInternally } from 'utils/bolt/index';

export default class BoltApp extends BaseComp.default {
	componentDidUpdate() {
		const store = Store.get();
		// const showtimesOverlayOpen = store.header?.showtimesOverlay;
		// const videoOverlayOpen = store.header?.videoOverlayOpen;
		const map = store.header?.activeSection === 'map';

		if (!map && typeof window.__manualMapCleanup === 'function') {
			window.__manualMapCleanup();
			delete window.__manualMapCleanup;
		}

		
		// if (this.prevVideoOverlayOpen && !videoOverlayOpen || this.prevShowtimesOverlayOpen && !showtimesOverlayOpen) {
		// 	if (typeof window.__manualMapReload === 'function') {
		// 		navigateInternally('map');
		// 		window.__manualMapReload();
		// 	}
		// }
		

		// this.prevShowtimesOverlayOpen = showtimesOverlayOpen;
		// this.prevVideoOverlayOpen = videoOverlayOpen;
	}
}